
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoySphericalSquare as ObiBuoySphericalSquareElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-spherical-square.js';
 
 
 

 
 export const ObiBuoySphericalSquare = createComponent({
   react: React,
   tagName: 'obi-buoy-spherical-square',
   elementClass: ObiBuoySphericalSquareElement,
   events: {
     
   }
  });
 
 